import { render, staticRenderFns } from "./PostView.vue?vue&type=template&id=3510392b&"
import script from "./PostView.vue?vue&type=script&lang=js&"
export * from "./PostView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports